module.exports = "#define GLSLIFY 1\nuniform float alpha;\n\nuniform vec3 colorA;\n\nuniform vec3 colorB;\n\nvarying vec2 ssPosition;\n\nvarying float vTimer;\n\nfloat when_lt(float x, float y) {\n   return max(sign(y - x), 0.0);\n}\n\nuniform float lightLength;\n\nvoid main()\n{\n\tfloat sspX = 1.0 - (ssPosition.x + 1.0) / 2.0;\n\t\n\tgl_FragColor = vec4(1.0 - sspX,1.0, 1.0, 1.0);\n\t// gl_FragColor = vec4(vec3(1.0), vv);\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/scripts/Trail/modules/trail/material/shader/picking.glsl
// module id = zlXq
// module chunks = 1